import React from "react";
import { Icon } from "../Icon";
import { cn } from "../lib/utils";

interface BackButtonProps {
  /** Ziel des Zurück-Links (echtes Ziel, nicht history.back). */
  href: string;
  /** Sichtbarer Text, z. B. "Zurück zur Übersicht". */
  label: string;
  className?: string;
}

/**
 * Kanonischer Zurück-Link: subtiler Top-Left-Link mit chevronLeft-Pfeil,
 * kein gefüllter Button. Ersetzt uneinheitliche Varianten (←, FaArrowLeft).
 * Theme-aware über text-content-2 → hover:text-content.
 */
export const BackButton: React.FC<BackButtonProps> = ({ href, label, className }) => (
  <a
    href={href}
    className={cn(
      "inline-flex w-fit items-center gap-1 text-sm text-content-2 hover:text-content",
      className,
    )}
  >
    <Icon name="chevronLeft" size={14} />
    {label}
  </a>
);

export default BackButton;
